<template>
    <div class="signBox">
        <div class="imgBox">
            <div class="bannerBox">
                <div class="titleBox">
                    <img src="../assets/images/LOGOs.png" alt="" style="height:43px">
                    <p>生物医疗销售全流程管理系统&nbsp;&nbsp; |&nbsp;&nbsp; 密码重置</p>
                </div>
                <div class="whiteBox">
                    <div class="titles">请选择验证方式</div>
                    <div class="buttonBox">
                        <div class="selebutton" @click="go(index)" :class="{'active':index==indx}" v-for="(item,index) in list" :key="index">{{item}}</div>
                    </div>
                    <div v-show="indx==0" class="checkingBox">
                        <div class="checking">
                            <div v-if="!showHidden" class="formBox">
                                <el-form :inline="true" :rules="emailrules" ref="emailForm" :model="emailForm" class="demo-form-inline h-formBorder h-formBorder-4">
                                    <el-form-item class="h-elformWrap-5"  prop="email" >
                                        <el-input v-model="emailForm.email" placeholder="请输入有效的邮箱地址"></el-input>
                                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="tijiao">提交</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div  v-if="showHidden">
                                <div class="sendBox">
                                    我们已向您的注册邮箱
                                    <span style="color: #2785e7;">{{emailForm.email}}</span>
                                    发送了一封密码找回邮件，请您注意接收邮件
                                </div>
                                <!--<div class="jieshouBox" style="margin-top:20px">
                                    去邮箱接收邮件
                                </div>-->
                                <div class="sendBoxs">
                                    请注意查收邮件，并按照邮件中的提示操作，完成安全认证。没有收到？
                                    <span style="color: #2785e7;cursor: pointer;" @click="resubmit">重新发送</span>
                                </div>
                            </div>
                            <div class="h-txtCenter h-mrt60" style="margin-left:-100px;">
                                <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="returnTable">返回</el-button>
                            </div>
                        </div>
                    </div>
                    <div v-show="indx==1" class="checkingBox">
                        <div class="checking">
                            <div class="formBox">
                                <el-form :inline="true" :rules="phonerules" ref="phoneForm" :model="phoneForm" class="demo-form-inline h-formBorder h-formBorder-4">
                                    <el-form-item class="h-elformWrap-5"  prop="phone">
                                        <el-input v-model="phoneForm.phone" placeholder="请输入手机号码"></el-input>
                                        <el-button @click="submitUpload" :class="{disabled: !this.canClick}" style="width:170px;">{{content}}</el-button>
                                    </el-form-item>
                                    <el-form-item class="h-elformWrap-5"  prop="yzm">
                                        <el-input v-model="phoneForm.yzm" placeholder="输入验证码"></el-input>
                                    </el-form-item>
                                    <el-form-item class="h-elformWrap-5"  prop="pass">
                                        <el-input type="password" v-model="phoneForm.pass" placeholder="输入密码 (密码必须包含大写字母、小写字母、数字其中的两种)"></el-input>
                                    </el-form-item>
                                    <div class="redText" :class="{'active':jiaoyan}">
                                        * 密码必须包含大写字母、小写字母、数字其中的两种
                                    </div>
                                    <!-- <div class="mimaBox">
                                        <div class="mima">
                                            <div class="mimaY" :class="{'active':mimaI==index}" v-for="(item,index) in mimaList" :key="index"></div>
                                        </div>
                                    </div> -->
                                    <el-form-item class="h-elformWrap-5"  prop="repass">
                                        <el-input type="password" v-model="phoneForm.repass" placeholder="重新输入一次"></el-input>
                                    </el-form-item>
                                    <el-form-item class="h-elformWrap-5" style="margin-top:38px;">
                                        <drag-verify
                                            :width="width"
                                            :height="height"
                                            :text="text"
                                            :success-text="successText"
                                            :background="background"
                                            :progress-bar-bg="progressBarBg"
                                            :completed-bg="completedBg"
                                            :handler-bg="handlerBg"
                                            :handler-icon="handlerIcon"
                                            :text-size="textSize"
                                            :success-icon="successIcon"
                                            :circle="isCircle"
                                            color="#5e5e5e"
                                            ref="Verify"
                                        >
                                        </drag-verify>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="jieshouBox" style="margin-top:57px;">
                                重置密码
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottoms">
                Copyright Haier 2019. All rights reserved
            </div>
        </div>
    </div>
</template>
<script>
	import ss from '../api/SystemService'
	import store from "../store";
import dragVerify from 'vue-drag-verify'

export default {
    data(){
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
            if (this.phoneForm.repass !== '') {
                this.$refs.phoneForm.validateField('pass');
            }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.phoneForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return{
            jiaoyan:false,
            content: '发送验证码',
            totalTime: 60,
            canClick: true ,//添加canClick
            showHidden:false,
            handlerIcon: "fa fa-angle-double-right",
            successIcon: "fa fa-check",
            background: "#e8e8e8",
            progressBarBg: "#4b0",
            completedBg: "#66cc66",
            handlerBg: "#fff",
            text: "请按住滑块。拖动到最右边",
            successText: "验证成功",
            width: 514,
            height: 42,
            textSize: "14px",
            isCircle:false,
            // list:["邮箱验证","手机验证"],
            list:["邮箱验证"],
            indx:0,
            emailForm:{email:''},
            phoneForm:{
                phone:'',
                yzm:'',
                pass:'',
                repass:''
            },
            emailrules:{
                email: [{ required: true, trigger: "blur" ,message:"请输入您的邮箱"},
                     { pattern: /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/, message: '请输入正确的邮箱' }
                        ],
            },
            phonerules:{
                phone: [{ required: true, trigger: 'blur',message: "请输入您的手机号" }],
                pass: [{ validator: validatePass, trigger: 'blur' }],
                repass: [{ validator: validatePass2, trigger: 'blur' }],
            },
            mimaList:[1,2,3],
            mimaI:null
        }
    },
    components:{
        dragVerify
    },
    methods:{
        returnTable(){
            this.$router.go(-1)
        },
        go(index){
            this.indx = index;
        },
        tijiao(){
            // console.log(1)
            this.$refs.emailForm.validate((valid) => {
                if (valid) {
                    this.resubmit();
                } else {
                    this.$msg.msge("请完善信息后再提交！");
                    return false;
                }
            });
        },
        resubmit(){
            ss.ResetPassService.sendEmail(this.emailForm.email).then(rd => {
                if(rd.f){
                    this.$msg.msgs(rd.msg);
                    this.showHidden = true;
                }else{
                    this.$msg.msge(rd.msg)
                }
            })
        },
        submitUpload(){
            if(!this.canClick) return
            this.canClick  = false;
            this.content = this.totalTime +"s秒后重新发送"
            let clock = window.setInterval(() => {
            this.totalTime--
            this.content = this.totalTime + 's后重新发送'
            if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.content = '重新发送验证码'
                this.totalTime = 10
                this.canClick = true  //这里重新开启
            }
            },1000)
        }
    }
}
</script>
<style scoped>
.checkingBox .checking .formBox .disabled{
 background-color: #999;
 border-color: #dcdcdc;
 color:#ccc;
 cursor: not-allowed; 
}
.imgBox{
    width: 100%;
    height: 695px;
    background: url(../assets/images/signBJ.jpg) center/cover;
}
.bannerBox{
    width: 1041px;
    margin: 0 auto;
}
.titleBox{
    padding-top: 147px;
    display: flex;
}
.titleBox p{
    font-size: 30px;
    color: #ffffff;
    padding: 0;
    margin: 0;
    line-height: 50px;
    margin-left: 38px;
}
.titles{
    font-size: 18px;
	color: #0e75e9;
    position: relative;
    padding-left: 9px;
    border-left: 5px solid #0e75e9;
}
.whiteBox{
    width: 100%;
    margin-top: 30px;
    padding: 50px 44px;
    background-color: #ffffff;
	border-radius: 8px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.07);
    margin-bottom: 73px;
}

.buttonBox{
    display: flex;
    align-items: center;
    margin-top: 40px;
}
.buttonBox .selebutton{
    width: 133px;
	height: 46px;
	border-radius: 4px;
	border: solid 2px #d2d2d2;
    text-align: center;
    line-height: 42px;
    margin-left: 26px;
    cursor: pointer;
    color: #9a9a9a;
}
.buttonBox .selebutton.active{
	background-color: #1b78e6;
	border-color: #1b78e6;
    color: #fff;
}
.checkingBox{
    padding: 0 44px 0 174px;
    margin-top: 70px;
}
.checkingBox .checking{
    width: 100%;
}
.bottoms{
    background: #000;
    width: 100%;
    height: 53px;
    text-align: center;
    line-height: 53px;
    font-size: 14px;
    color: #a4a4a4;
	position: fixed;
	bottom: 0;
	left: 0;
}
.sendBox{
    width: 70%;
    text-align: center;
    font-size: 18px;
    color: #848484;
    line-height: 30px;
    margin-top: 45px;
}
.sendBoxs{
    width: 60%;
    margin-left: 10%;
    text-align: center;
    font-size: 16px;
    color: #848484;
    line-height: 30px;
    margin-bottom: 100px;
}
.jieshouBox{
    width: 50%;
    margin: 140px auto 28px auto;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    background: #2686e7;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 14%;
}
.mimaBox{
    width: 70%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.2rem;
}
.mimaBox .mima{
    display: flex;
    justify-content: center;
}
.mimaBox .mima .mimaY{
    width: 67px;
	height: 7px;
	background-color: #d2d2d2;
	border-radius: 4px;
    margin-right: 5px;
}
.mimaBox .mima .mimaY:last-child{
    margin-right: 0;
}
.mimaBox .mima .mimaY.active{
    background-color: #ffcb2c;
}
.formBox .active{
    color:   red;
}
.redText{
    font-size: 14px;
    color:   #d1d1d1;
    margin-bottom: 10px;
}
</style>
<style>
.el-form-item.h-elformWrap-5{
    width: 100%;
}
.el-form-item.h-elformWrap-5 .el-form-item__content{
    display: flex;
    width: 100%;
}
.el-form-item.h-elformWrap-5 .el-form-item__content .el-input{
    width: 70%;
    height: 50px;
}
.el-form-item.h-elformWrap-5 .el-form-item__content .el-input .el-input__inner{
    height: 50px;
}
.el-form-item.h-elformWrap-5 .el-form-item__content .el-button--default{
    margin-left: 5%;
    width: 20%;
    background: #2686e7;
    color: #fff;
    font-size: 18px;
}

</style>
